

function About() {
    return(
        <section>
        <div style={{height: "15vh"}}></div>
        <div style={{backgroundColor: 'black'}}></div>
        <div className = "all-four">

        <ul>
            <li>
                <img src="/assets/SPICEBOYZCHROME.png" alt="SpiceBoyz logo" className="small-image"  width="450" height="450" data-aos="fade-down"/></li>
            
          </ul> 
          
        </div>

         <div className ="aboutus" data-aos="fade-up">
            <h3>MISSION !</h3>
            <h4>At Spiceboyz, we are more than just a collective group; we are purveyors of fun and joy. Our mission is simple yet profound: to spread good vibes and purity wherever we go. Join us on our journey as we bring people together, one beat at a time, with an unwavering dedication to spreading happiness and pure joy.</h4>
            <h3>#SB4L</h3>
        </div>
        <div style={{height: "25vh"}}></div>
    </section>

    );
}

export default About;